module.exports = __webpack_public_path__ + "img/location.39c5315.svg";